const ENV = {
  PRODUCTION: 'production',
  DEVELOPMENT: 'development',
}

let config = {}
config = require(`./${ ENV.PRODUCTION }.js`)

export default { ...config }
